<span mat-dialog-title class="ace-heading-text-level-1">Exempt Revenue Code Unavailable</span>
<mat-dialog-content class="mat-typography" style="margin-top:40px;">
  <span  class="ace-heading-text-tabs-level-2">This Revenue Type is not setup for tax exemption. Please contact spACE AR support.</span>
</mat-dialog-content>
<mat-dialog-actions align="end">
   <button class="btn btn-primary btn-sm ace-blue" 
          [mat-dialog-close]="true" cdkFocusInitial>OK</button>
</mat-dialog-actions>
